import axios from 'axios'

export const retrieveGroups = async ({ state, commit, rootState }) => {
  const groups = await axios.get(rootState.parantion.baseUrl + '/v51/group?import=1',
    { headers: { 'X-CSRFToken': rootState.parantion.user.token } }).then(res => res.data.group)
  commit('SET_GROUPS', groups)
}

export const retrieveUsersFromGroups = async ({ state, commit, rootState }, groupname) => {
  const users = await axios.get(rootState.parantion.baseUrl + `/v51/group/${groupname}/user?import=1`,
    { headers: { 'X-CSRFToken': rootState.parantion.user.token } }).then(res => res.data.user)

  commit('ADD_USERS', {
    groupname,
    users
  })
}

export const importUser = async ({ state, commit, rootState }, user) => {
  const student = {
    rolegroup: 'Leerling',
    group: user.groupname,
    agreement: true,
    status: true
  }

  const response = await axios.post(rootState.parantion.baseUrl + '/v51/user/' + user.uh + '/import', student,
    { headers: { 'X-CSRFToken': rootState.parantion.user.token } })

  const folders = await axios.get(rootState.parantion.baseUrl + '/v51/folder', {
    params: {
      uid: response.data.uh
    }
  })

  const foldersToRemove = ['all_exports', 'all_imports']

  folders.data.folder
    .filter(folder => foldersToRemove.includes(folder.label))
    .forEach(folder => {
      console.log('folder', folder)
      axios.delete(rootState.parantion.baseUrl + '/v51/folder/' + folder.foid, {
        params: {
          uid: response.data.uh
        }
      })
    })
  return response.data.uh
}
